import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { KsTest2SampCard } from 'src/generated-sources';
import type { EChartsOption } from 'echarts';
import _ from 'lodash';
import { CardAction } from '@features/eda/worksheet/cards/events';
import { ColorsService } from '@shared/graphics/colors.service';
import { zipSameSize } from '@features/eda/echarts-utils';
import { filterName } from '@features/eda/pipes/filter-name.pipe';

@Component({
    selector: 'ks-test-2samp-card-body',
    templateUrl: './ks-test-2samp-card-body.component.html',
    styleUrls: [
        '../../../../shared-styles/test-conclusion.less',
        '../../../../shared-styles/stats-table.less',
        '../../../../shared-styles/card-layout.less',
        '../../../../shared-styles/chart.less',
        './ks-test-2samp-card-body.component.less'
    ]
})
export class KsTest2SampCardBodyComponent implements OnChanges {
    @Input() results: KsTest2SampCard.KsTest2SampCardResult;
    @Input() params: KsTest2SampCard;
    @Output() action = new EventEmitter<CardAction>();

    cdfChartOptions: EChartsOption;

    constructor(public colorsService: ColorsService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.results) {
            this.cdfChartOptions = this.results && this.buildChartOptions(this.results);
        }
    }

    get isRejected() {
        return this.results.pvalue <= (1 - this.params.confidenceLevel);
    }

    buildChartOptions(results: KsTest2SampCard.KsTest2SampCardResult): EChartsOption {
        return {
            color: ['#3398DB'],
            animation: false,
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    type: 'cross'
                }
            },
            grid: {
                left: 10,
                top: 10,
                right: 10,
                bottom: 0,
                containLabel: true,
            },
            xAxis: [{
                type: 'value',
                scale: true,
                axisTick: { show: true },
                axisLine: { show: true },
                axisLabel: { color: '#999999' }
            }],
            yAxis: {
                type: 'value',
                min: 0,
                max: 1,
                axisLine: { show: false },
                axisTick: { show: false },
                axisLabel: { color: '#999999' }
            },
            series: [
                {
                    type: 'line',
                    symbol: 'none',
                    step: 'middle',
                    data: zipSameSize(results.cdf1.xvals, results.cdf1.probs),
                    itemStyle: {
                        color: this.colorsService.getColorForVariable(filterName(this.results.groups[0].filter))
                    }
                },
                {
                    type: 'line',
                    step: 'middle',
                    symbol: 'none',
                    data: zipSameSize(results.cdf2.xvals, results.cdf2.probs),
                    itemStyle: {
                        color: this.colorsService.getColorForVariable(filterName(this.results.groups[1].filter))
                    }
                }
            ]
        };
    }
}
